<div class="dtf-accountdetails">
  <!--Announcement Banner Code-->
  <div class="dtf-alertpage"></div>


  <div *ngIf="(this.bodyLoaded)" class="mbfs-payoff-quote-spinner">

    <!--Default page to load while waiting for Redirection to Classic-->
    <section class="mbfs-home-hero"
      style="background-image: url(/static/assets/img/dtf-assets/images/redesign/mbfs_top_image_and_tint.jpg);">
      <section class="mbfs-home-hero__header">
        <h2 class="mbfs-home-hero__header-subtitle">
          {{ 'LoaderPages.BannerHeader' | translate }}
        </h2>
        <p class="mbfs-home-hero__header-text-demi">
          {{ 'LoaderPages.Loading' | translate }}
        </p>

        <!--Spinner-->
        <div class="mbfs-loading-spinner-overlay"></div>
        <div class="mbfs-loading-spinner"> </div>
      </section>
    </section>
  </div>

   <div class="container_dashboard" *ngIf="!this.bodyLoaded && !isCanadaPortal">
    <h4 *ngIf="SelectContractCopy" class="dtfbrochures__header_dark">{{ 'LoginHeader.ContractCopy' | translate }}</h4>
    <h4 *ngIf="SelectTitleRelease" class="dtfbrochures__header_dark">{{ 'LoginHeader.StatetoStateTransfer' | translate }}</h4>
    <p *ngIf="SelectContractCopy">{{ 'LoginHeader.ContractText' | translate }}</p>
    <p *ngIf="SelectTitleRelease">{{ 'LoginHeader.TitleText' | translate }}</p>
      <div class="dtfbrochures__containerlong">
          <div class="row4">
            <div class="dynamicflexbox">
              <section class="section">
                <div class="section__item section__item--start">
                  <h4 class="dtfbrochures__header5">{{ 'Dashboard.NumAccounts' | translate }}</h4>
                  <h3 class="dtfbrochures__header6">{{this.recAccCount}}</h3>
                </div>
                <div class="section__item section__item--end">
                  <h4 class="dtfbrochures__header5">{{ 'Dashboard.CurrentDue' | translate }}</h4>
                  <h3 class="dtfbrochures__header6">${{this.totalDue}}</h3>
                </div>
              </section>
            </div>
          </div>
        </div>
    </div>
 
  
  <!--CA-->
  <div class="container_dashboard" *ngIf="!this.bodyLoaded && isCanadaPortal">
    <h4 *ngIf="SelectContractCopy" class="dtfbrochures__header_dark">{{ 'LoginHeader.ContractCopy' | translate }}</h4>
    <h4 *ngIf="SelectTitleRelease" class="dtfbrochures__header_dark">{{ 'LoginHeader.StatetoStateTransfer' | translate }}</h4>
      <div class="dtfbrochures__containerlong">
          <div class="row4">
            <div class="dynamicflexbox">
              <section class="section">
                <div class="section__item section__item--start">
                  <h4 class="dtfbrochures__header5">{{ 'Dashboard.NumAccounts' | translate }}</h4>
                  <h3 class="dtfbrochures__header6">{{this.recAccCount}}</h3>
                </div>
                <div class="section__item section__item--end">
                  <h4 class="dtfbrochures__header5">{{ 'Dashboard.CurrentDue' | translate }}</h4>
                  <h3 class="dtfbrochures__header6">${{this.totalDue}}</h3>
                </div>
              </section>
            </div>
          </div>
        </div>
    </div>
  
  <div class="container_dashboard">
    <div class="dtf-accountdetails" style="padding-bottom: 21px;">

      <!-- <div class="example-button-row" *ngIf="!this.bodyLoaded && !isCanadaPortal">
        <mat-button-toggle-group [value]="selectedState" (change)="onChangeButton($event)">
          <mat-button-toggle [value]="toggleEnum.Option1">{{ 'LoginHeader.ContractCopy' | translate }}</mat-button-toggle>
          <mat-button-toggle [value]="toggleEnum.Option2">{{ 'LoginHeader.TitleStateTransfer' | translate }}</mat-button-toggle>
        </mat-button-toggle-group>
      </div> -->

      <div class="container_dashboard && tile">
        <div class="mbfs-contact-us-page-inner" style="padding-top: 21px; padding-bottom: 15px; padding-left: 21px; padding-right: 21px;">
          <div *ngIf="SelectContractCopy">              
                <form #form="ngForm" (ngSubmit)="docRequest($event)"> 
                  <div class="form-group">
                    <div class="row">
                      <div class="col-md-6">
                        <b for="name">{{ 'DocumentCenter.ContactName' | translate }}*</b><br>
                        <div class="col">
                          <input class="form-control" type="text" name="name" id="name"
                          [(ngModel)]="name"  required validateonblur value="" autocomplete="off">
                        </div>
                      </div>
                      <div class="col-md-6">
                        <b for="phoneNumber">{{ 'DocumentCenter.PhoneNumber' | translate }}*</b><br>
                        <div class="col">
                          <input class="form-control" type="number" name="phoneNumber" id="phoneNumber"
                          [(ngModel)]="phoneNumber" required validateonblur value="" autocomplete="off" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength="10" (input)="inputValidator($event)">
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <b for="name">{{ 'DocumentCenter.EmailAddress' | translate }}</b><br>
                        <div class="col">
                          <input class="form-control" type="text" name="emailAddress" id="emailAddress"
                          required validateonblur [(ngModel)]="emailAddress" value="" readonly autocomplete="off">
                        </div>
                      </div>
                    </div>
                  </div>
                <div class="row">
                  <div class="col">
                    <div *ngIf="isCanadaPortal">
                      <p>{{ 'DocumentCenter.ContractCopyText1' | translate }} <b style="color: red;">{{ 'DocumentCenter.ContractCopyText2' | translate }}</b></p>
                    </div>
                    <div *ngIf="!isCanadaPortal">
                      <p>{{ 'DocumentCenter.ContractCopyText1' | translate }}</p>
                      <p><b style="color: red;">{{ 'DocumentCenter.ContractCopyText2' | translate }} </b> 
                        <a href="{{this.usUrl}}/home/manageYourProfile">{{ 'Dashboard.ClickHereButton' | translate }} </a></p>
                    </div>
                  </div>
                </div>
                <div class="accountflex">
                  <h1 class="mercedes-me-login__column-headline2"> </h1>
                  <mat-form-field class="example-form-field" appearance="outline">
                    <mat-label>{{ 'AccountDetails.Search' | translate }}</mat-label>
                    <input matInput  (keyup)="applyFilter($event)" placeholder="Account Number or Status" #input type="text" [(ngModel)]="value">
                    <img matSuffix class="example-form-img" src="/static/assets/img/dtf-assets/images/redesign/DTF_SearchButton_copy.png">
                  </mat-form-field>
                </div>
                <div *ngIf="(!this.tableLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
                  <!--Spinner on Login Load-->
                  <div class="demo-container">
                    <span>{{ 'Invoice.Loading' | translate }}</span>
                    <div class="progress-bar">
                      <div class="progress-bar-value"></div>
                    </div>
                  </div>
                  <br>
                </div>
                <mat-table [dataSource]="dataSource" multiTemplateDataRows  class="mat-elevation-z8" matSort>
            <!--US/EN Table loading-->
              <ng-container matColumnDef="{{column.name}}" *ngFor="let column of initColumns; last as isLast; first as isFirst;">
                <div *ngIf="isFirst"> 
                  <mat-checkbox  [ngClass]="{'white-border': !isChecked}" (change)="$event ? masterToggle() : null"
                  [checked]="selection.hasValue() && isAllSelected()"
                  [indeterminate]="selection.hasValue() && !isAllSelected()"  >
              </mat-checkbox></div>
                <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef>
                  <div *ngIf="!isFrench"> {{column.display}}</div>
                  <div *ngIf="isFrench"> {{column.displayFR}}</div>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <div *ngIf="isFirst"   > <mat-checkbox (click)="$event.stopPropagation()"
                    (change)="$event ? selection.toggle(element) : null"
                    [checked]="selection.isSelected(element)" >
                </mat-checkbox></div>
                  <span class="mobile-label">
                    <div *ngIf="!isFrench"> {{column.display}} :</div>
                    <div *ngIf="isFrench"> {{column.displayFR}} :</div>
                  </span>
                  <div *ngIf="column.dispFormat=='currency'"> <!--Formats Currency Columns-->
                    {{element[column.name] | currency:'USD':true:'1.2-2'}}
                  </div>
                  <div *ngIf="column.dispFormat=='contract'"> <!--Formats Contract String Columns-->
                    {{element[column.name]}}
                  </div>
                  <div *ngIf="column.dispFormat==''"> <!--Formats String Columns-->
                    {{element[column.name]}}
                  </div>
                  <div *ngIf="column.dispFormat=='date'"> <!--Formats date Columns-->
                    {{element[column.name] | date:'MM/dd/yyyy'}}
                  </div>
                </mat-cell>
              </ng-container>
      
              <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
            <ng-container matColumnDef="accountDetailsRes">
              <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
                [attr.colspan]="displayedColumns.length">
              </mat-cell>
            </ng-container>
      
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let element; columns: displayedColumns;"
                class="example-element-row"
                [class.example-expanded-row]="accountDetailsRes === element"
                (click)="accountDetailsRes = accountDetailsRes === element ? null : element">
            </mat-row>
            <mat-row *matRowDef="let row; columns: ['accountDetailsRes']" class="example-detail-row"></mat-row>
      
            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" colspan="4" *ngIf="!isFrench">No data matching the filter "{{input.value}}"</td>
              <td class="mat-cell" colspan="4" *ngIf="isFrench">Aucune donnée correspondant au filtre "{{input.value}}"</td>
            </tr>
      
                </mat-table>
                <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
                <button  type="submit" [disabled]="this.disabledFlag"  class="mbfs-button">{{ 'LoginModal.Submit' | translate }}</button>
          </form>
         </div>

         <div *ngIf="SelectTitleRelease">   

            <form *ngIf="!isCanadaPortal" #form="ngForm" (ngSubmit)="docRequest($event)"> 
              <div class="form-group">
                <div class="row">
                  <div class="col-md-6">
                    <b for="name">{{ 'DocumentCenter.ContactName' | translate }}</b><br>
                    <div class="col">
                      <input class="form-control" type="text" name="name" id="name"
                      [(ngModel)]="name"  required validateonblur value="" autocomplete="off">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <b for="phoneNumber">{{ 'DocumentCenter.PhoneNumber' | translate }}</b><br>
                    <div class="col">
                      <input class="form-control" type="number" name="phoneNumber" id="phoneNumber"
                      [(ngModel)]="phoneNumber" required validateonblur value="" autocomplete="off" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"  maxlength="10" (input)="inputValidator($event)">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <b for="fax">{{ 'DocumentCenter.DMVFaxNo' | translate }}</b><br>
                    <div class="col">
                      <input class="form-control" type="text" name="fax" id="fax"
                      [(ngModel)]="fax" required validateonblur value="" autocomplete="off">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <b for="nameOfDMV">{{ 'DocumentCenter.NameOfDMV' | translate }}</b><br>
                    <div class="col">
                      <input class="form-control" type="text" name="nameOfDMV" id="nameOfDMV" 
                      [(ngModel)]="nameOfDMV" required validateonblur value="" autocomplete="off">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <b for="DMVAddress">{{ 'DocumentCenter.DMVStreet' | translate }}</b><br>
                    <div class="col">
                      <input class="form-control" type="text" name="DMVAddress" id="DMVAddress"
                      [(ngModel)]="DMVAddress" required validateonblur value="" autocomplete="off">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <b for="DMVPhone">{{ 'DocumentCenter.DMVPhone' | translate }}</b><br>
                    <div class="col">
                      <input class="form-control" type="text" name="DMVPhone" id="DMVPhone" 
                      [(ngModel)]="DMVPhone" required validateonblur value="" autocomplete="off">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <b for="DMVStateCityZip">{{ 'DocumentCenter.DMVState' | translate }}</b><br>
                    <div class="col">
                      <input class="form-control" type="text" name="DMVStateCityZip" id="DMVStateCityZip"
                      [(ngModel)]="DMVStateCityZip" required validateonblur value="" autocomplete="off">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <b for="odometer">{{ 'DocumentCenter.Odometer' | translate }}</b><br>
                    <div class="col">
                      <input class="form-control" type="text" name="odometer" id="odometer"
                      [(ngModel)]="odometer" required validateonblur value="" autocomplete="off">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <b for="name">{{ 'DocumentCenter.EmailAddress' | translate }}</b><br>
                    <div class="col">
                      <input class="form-control" type="text" name="emailAddress" id="emailAddress"
                      required validateonblur [(ngModel)]="emailAddress" value="" readonly autocomplete="off">
                    </div>
                  </div>
                </div>
              </div>
          
            <div class="row">
              <div class="col">
                <p>{{ 'DocumentCenter.TitleReleaseText' | translate }}</p>
              </div>
            </div>
            <div class="accountflex">
              <h1 class="mercedes-me-login__column-headline2"> </h1>
              <mat-form-field class="example-form-field" appearance="outline">
                <mat-label>{{ 'AccountDetails.Search' | translate }}</mat-label>
                <input matInput  (keyup)="applyFilter($event)" placeholder="Account Number or Status" #input type="text" [(ngModel)]="value">
                <img matSuffix class="example-form-img" src="/static/assets/img/dtf-assets/images/redesign/DTF_SearchButton_copy.png">
              </mat-form-field>
            </div>
            <div *ngIf="(!this.tableLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
              <!--Spinner on Login Load-->
              <div class="demo-container">
                <span>{{ 'Invoice.Loading' | translate }}</span>
                <div class="progress-bar">
                  <div class="progress-bar-value"></div>
                </div>
              </div>
              <br>
            </div>
            <mat-table [dataSource]="dataSource" multiTemplateDataRows  class="mat-elevation-z8" matSort>
        <!--US/EN Table loading-->
          <ng-container matColumnDef="{{column.name}}" *ngFor="let column of initColumns; last as isLast; first as isFirst;">
            <div *ngIf="isFirst"> 
              <mat-checkbox  [ngClass]="{'white-border': !isChecked}" (change)="$event ? masterToggle() : null"
              [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()"  >
          </mat-checkbox></div>
            <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef>
              <div *ngIf="!isFrench"> {{column.display}}</div>
              <div *ngIf="isFrench"> {{column.displayFR}}</div>
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <div *ngIf="isFirst"   > <mat-checkbox (click)="$event.stopPropagation()"
                (change)="$event ? selection.toggle(element) : null"
                [checked]="selection.isSelected(element)" >
            </mat-checkbox></div>
              <span class="mobile-label">
                <div *ngIf="!isFrench"> {{column.display}} :</div>
                <div *ngIf="isFrench"> {{column.displayFR}} :</div>
              </span>
              <div *ngIf="column.dispFormat=='currency'"> <!--Formats Currency Columns-->
                {{element[column.name] | currency:'USD':true:'1.2-2'}}
              </div>
              <div *ngIf="column.dispFormat=='contract'"> <!--Formats Contract String Columns-->
                {{element[column.name]}}
              </div>
              <div *ngIf="column.dispFormat==''"> <!--Formats String Columns-->
                {{element[column.name]}}
              </div>
              <div *ngIf="column.dispFormat=='date'"> <!--Formats date Columns-->
                {{element[column.name] | date:'MM/dd/yyyy'}}
              </div>
            </mat-cell>
          </ng-container>
  
          <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
        <ng-container matColumnDef="accountDetailsRes">
          <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
            [attr.colspan]="displayedColumns.length">
          </mat-cell>
        </ng-container>
  
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let element; columns: displayedColumns;"
            class="example-element-row"
            [class.example-expanded-row]="accountDetailsRes === element"
            (click)="accountDetailsRes = accountDetailsRes === element ? null : element">
        </mat-row>
        <mat-row *matRowDef="let row; columns: ['accountDetailsRes']" class="example-detail-row"></mat-row>
  
        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="4" *ngIf="!isFrench">No data matching the filter "{{input.value}}"</td>
          <td class="mat-cell" colspan="4" *ngIf="isFrench">Aucune donnée correspondant au filtre "{{input.value}}"</td>
        </tr>
  
            </mat-table>
            <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
            <button  type="submit" [disabled]="!this.tableLoaded"  class="mbfs-button">{{ 'LoginModal.Continue' | translate }}</button>
           </form>

           <form *ngIf="isCanadaPortal" #form="ngForm" (ngSubmit)="docRequest($event)"> 
            <div class="form-group">
              <div class="row">
                <div class="col-md-6">
                  <b for="name">{{ 'DocumentCenter.ContactName' | translate }}</b><br>
                  <div class="col">
                    <input class="form-control" type="text" name="name" id="name"
                    [(ngModel)]="name"  required validateonblur value="" autocomplete="off">
                  </div>
                </div>
                <div class="col-md-6">
                  <b for="phoneNumber">{{ 'DocumentCenter.PhoneNumber' | translate }}</b><br>
                  <div class="col">
                    <input class="form-control" type="number" name="phoneNumber" id="phoneNumber"
                    [(ngModel)]="phoneNumber" required validateonblur value="" autocomplete="off" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength="10" (input)="inputValidator($event)">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <b for="name">{{ 'DocumentCenter.EmailAddress' | translate }}</b><br>
                  <div class="col">
                    <input class="form-control" type="text" name="emailAddress" id="emailAddress"
                    required validateonblur [(ngModel)]="emailAddress" value="" readonly autocomplete="off">
                  </div>
                </div>
              </div>
            </div>
          <div class="row">
            <div class="col">
              <p>{{ 'DocumentCenter.TitleReleaseText' | translate }}</p>
            </div>
          </div>
          <div class="accountflex">
            <h1 class="mercedes-me-login__column-headline2"> </h1>
            <mat-form-field class="example-form-field" appearance="outline">
              <mat-label>{{ 'AccountDetails.Search' | translate }}</mat-label>
              <input matInput  (keyup)="applyFilter($event)" placeholder="Account Number or Status" #input type="text" [(ngModel)]="value">
              <img matSuffix class="example-form-img" src="/static/assets/img/dtf-assets/images/redesign/DTF_SearchButton_copy.png">
            </mat-form-field>
          </div>
          <div *ngIf="(!this.tableLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
            <!--Spinner on Login Load-->
            <div class="demo-container">
              <span>{{ 'Invoice.Loading' | translate }}</span>
              <div class="progress-bar">
                <div class="progress-bar-value"></div>
              </div>
            </div>
            <br>
          </div>
          <mat-table [dataSource]="dataSource" multiTemplateDataRows  class="mat-elevation-z8" matSort>
      <!--US/EN Table loading-->
        <ng-container matColumnDef="{{column.name}}" *ngFor="let column of initColumns; last as isLast; first as isFirst;">
          <div *ngIf="isFirst"> 
            <mat-checkbox  [ngClass]="{'white-border': !isChecked}" (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"  >
        </mat-checkbox></div>
          <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef>
            <div *ngIf="!isFrench"> {{column.display}}</div>
            <div *ngIf="isFrench"> {{column.displayFR}}</div>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div *ngIf="isFirst"   > <mat-checkbox (click)="$event.stopPropagation()"
              (change)="$event ? selection.toggle(element) : null"
              [checked]="selection.isSelected(element)" >
          </mat-checkbox></div>
            <span class="mobile-label">
              <div *ngIf="!isFrench"> {{column.display}} :</div>
              <div *ngIf="isFrench"> {{column.displayFR}} :</div>
            </span>
            <div *ngIf="column.dispFormat=='currency'"> <!--Formats Currency Columns-->
              {{element[column.name] | currency:'USD':true:'1.2-2'}}
            </div>
            <div *ngIf="column.dispFormat=='contract'"> <!--Formats Contract String Columns-->
              {{element[column.name]}}
            </div>
            <div *ngIf="column.dispFormat==''"> <!--Formats String Columns-->
              {{element[column.name]}}
            </div>
            <div *ngIf="column.dispFormat=='date'"> <!--Formats date Columns-->
              {{element[column.name] | date:'MM/dd/yyyy'}}
            </div>
          </mat-cell>
        </ng-container>

        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
      <ng-container matColumnDef="accountDetailsRes">
        <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
          [attr.colspan]="displayedColumns.length">
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let element; columns: displayedColumns;"
          class="example-element-row"
          [class.example-expanded-row]="accountDetailsRes === element"
          (click)="accountDetailsRes = accountDetailsRes === element ? null : element">
      </mat-row>
      <mat-row *matRowDef="let row; columns: ['accountDetailsRes']" class="example-detail-row"></mat-row>

      <!-- Row shown when there is no matching data. -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4" *ngIf="!isFrench">No data matching the filter "{{input.value}}"</td>
        <td class="mat-cell" colspan="4" *ngIf="isFrench">Aucune donnée correspondant au filtre "{{input.value}}"</td>
      </tr>

          </mat-table>
          <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
          <button  type="submit" [disabled]="!this.tableLoaded"  class="mbfs-button">{{ 'LoginModal.Submit' | translate }}</button>
         </form>
         </div>
          </div>
      </div>
    </div>
  </div>



</div>